import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Landing route for the Shopify admin "Open in Operations Hub" link
// (admin link extension in the Order Status app, target
// admin.order-details.action.link). Shopify appends the resource id and the
// shop domain, e.g. /shopify/open?id=7205373771954&shop=soccerpostshop.myshopify.com
// (details pages send `id`; index selection links send `ids[]`). Map the shop
// to our store slug and jump to the order.
const SHOP_TO_STORE = {
    soccerpostshop: 'soccerpost',
    'surf-soccerpost': 'surf',
    'rush-soccerpost': 'rush',
    citysportsnj: 'citysports',
};

export function orderPathFromShopifyLink(params) {
    const raw = params.get('id') || params.get('ids[]') || params.get('ids') || '';
    const id = String(raw).split(',')[0].split('/').pop().replace(/\D/g, '');
    const shop = (params.get('shop') || '').replace(/\.myshopify\.com$/i, '').toLowerCase();
    const store = SHOP_TO_STORE[shop] || 'soccerpost';
    return id ? `/store/${store}/orders/${id}?loc=all` : `/store/${store}/orders`;
}

export default function ShopifyOpenRedirect() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    useEffect(() => { navigate(orderPathFromShopifyLink(params), { replace: true }); }, [navigate, params]);
    return null;
}
